import { Loader } from "@fanduel/og-fe-library";
import cx from "classnames";
import ArticleCard from "@/components/articleCard";
import { Article } from "@/graphql/gql/graphql";
import styles from "./sport.module.scss";

interface MoreNewsProps {
  articles: Article[];
  loadMore: () => void;
  hasMore: boolean;
  origin: string;
  isLoading?: boolean;
}

const MoreNews = ({
  articles,
  loadMore,
  hasMore,
  origin,
  isLoading,
}: MoreNewsProps) => (
  <div>
    <div className={styles.moreArticlesContainer}>
      {articles.map((article) => (
        <ArticleCard
          key={article.id}
          image={article.hero?.imageUrl?.url}
          title={article.title}
          publishedOn={article.firstPublishedAt}
          description={article.description}
          link={`/${article.slug}`}
          origin={origin}
          sportName={article.sport.name}
          sportSlug={article.sport.slug}
          author={article.author}
          addBackground
        />
      ))}
    </div>
    {isLoading ? (
      <Loader className={styles.offset} size="medium" />
    ) : (
      <div className={styles.btnContainer}>
        {hasMore && (
          <button
            type="button"
            aria-label="load more"
            className={cx(styles.offset, styles.loadMoreBtn)}
            onClick={loadMore}
          >
            Show More News
          </button>
        )}
      </div>
    )}
  </div>
);

export default MoreNews;
